import { render } from "./AddContribute.vue?vue&type=template&id=62bd22da"
import script from "./AddContribute.vue?vue&type=script&lang=js"
export * from "./AddContribute.vue?vue&type=script&lang=js"

import "./AddContribute.vue?vue&type=style&index=0&id=62bd22da&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__